import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import PlanID from '@/App/Plan/Entity/PlanID'
import type {
    PlanData,
    PlanFeatureDisplayType,
    PlanPeriodEnum,
    PlanTypeEnum,
} from '@/Shared/AutoGenerated/Main'

export default class Plan {
    constructor(
        public readonly id: PlanID,
        public readonly name: string,
        public readonly description: string | null,
        public readonly price: number,
        public readonly type: PlanTypeEnum,
        public readonly period: PlanPeriodEnum,
        public readonly periodLabel: string,
        public readonly highlight: boolean,
        public readonly featuresDisplay: PlanFeatureDisplayType[],
        public readonly paddlePriceId: string | null,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: PlanData): Plan {
        return new Plan(
            new PlanID(entityData.id),
            entityData.name,
            entityData.description,
            entityData.price,
            entityData.type,
            entityData.period,
            entityData.periodLabel,
            entityData.highlight,
            entityData.featuresDisplay,
            entityData.paddlePriceId,
        )
    }

    static hydrateMultiple(entitiesData: PlanData[]): Plan[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
